import {Component, OnInit, ViewChild} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import {PositionService} from '../services/position.service';
import {DeviceService} from '../services/device.service';
import {UserService} from '../services/user.service';
import {Message} from 'primeng/primeng';
import {AddressService} from '../services/address.service';
import {Table} from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-distance-traveled-report',
    templateUrl: './distance-traveled-report.component.html',
    styleUrls: ['./distance-traveled-report.component.css']
})
export class DistanceTraveledReportComponent implements OnInit {

    fileName: String;
    groupBy: String;
    position: any;
    options: any;
    overlays: any[];
    displayLocation: boolean = false;
    records: any [];
    devices: SelectItem[];
    dateOptions: SelectItem[];
    groupsBy: SelectItem[];
    dateOption: any;
    idDevice: String;
    disabledInitialDate: boolean;
    disabledFinalDate: boolean;
    initialDate: Date;
    finalDate: Date;
    msgs: Message[] = [];
    blockedDocument: boolean = false;
    cols: any[];
    distanceTotal: number;
    maxDays: number = 35;
    totalDurationOn: number;
    totalDurationOff: number;
    totalDurationLeisure: number;

    @ViewChild('dt') table: Table;

    constructor(private positionService: PositionService, private deviceService: DeviceService,
                private userService: UserService, private addressService: AddressService) {
    }

    ngOnInit() {
        this.cols = [
            {field: 'name', header: 'NOMBRE'},
            {field: 'from', header: 'DESDE'},
            {field: 'fromAddress', header: 'DIRECCION INICIAL'},
            {field: 'to', header: 'HASTA'},
            {field: 'toAddress', header: 'DIRECCION FINAL'},
            {field: 'distance', header: 'DISTANCIA (km)'},
            {field: 'duration', header: 'DURACION'},
            {field: 'speed', header: 'VELOCIDAD MAXIMA (km/hr)'},
            {field: 'engineHours', header: 'TIEMPO DE MOTOR'}
        ];
        this.dateOptions = [
            {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
            {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
            {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
            {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
        ];
        this.groupsBy = [
            {label: 'Ninguno', value: ''},
            {label: 'Dia', value: 'D'},
            {label: 'Semana', value: 'W'}
        ];

        this.devices = [];
        this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
            let response: any = data;
            response.devices.forEach(item => {
                this.devices.push({label: item.name, value: item.idDevice});
            });
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
        this.dateOption = '7';
        this.groupBy = '';
        this.changeDate();
    }

    changeDate() {
        this.disabledInitialDate = true;
        this.disabledFinalDate = true;
        const dateTime = new Date();
        if (this.dateOption === 'T') {
            this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
            this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
        } else if (this.dateOption === 'Y') {
            this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 1, 0, 0, 0));
            this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 1, 23, 59, 59));
        } else if (this.dateOption === '7') {
            this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 6, 0, 0, 0));
            this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
        } else {
            this.disabledInitialDate = false;
            this.disabledFinalDate = false;
        }
    }

    diferenciaEntreFechasEnDias(a: Date, b: Date): number {
        return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar() {
        if (this.table) {
            this.table.first = 1;
        }

        this.fileName = 'distanciaRecorrida';
        this.devices.forEach(item => {
            if (item.value === this.idDevice) {
                this.fileName = this.fileName + item.label;
            }
        });

        if (this.diferenciaEntreFechasEnDias(this.initialDate, this.finalDate) > this.maxDays) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'El rango de fechas no debe exceder los ' + this.maxDays + ' dias'
            }];
            return;
        }
        if (this.initialDate >= this.finalDate) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'La fecha final debe ser superior a la fecha inicial'
            }];
            return;
        }

        this.blockedDocument = true;

        this.positionService.findDistanceFuelConsumption(this.idDevice, this.initialDate, this.finalDate, this.groupBy).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.totalDurationOn = response.totalDurationOn;
                this.totalDurationOff = response.totalDurationOff;
                this.totalDurationLeisure = response.totalDurationLeisure;
                this.distanceTotal = response.totalDistance;
                this.records = [...response.records];
                this.records.forEach(record => {
                    record.latitudeFrom = record.latitudeFrom.toFixed(6);
                    record.longitudeFrom = record.longitudeFrom.toFixed(6);
                    record.latitudeTo = record.latitudeTo.toFixed(6);
                    record.longitudeTo = record.longitudeTo.toFixed(6);
                    record.latLngTo = record.latitudeTo + ', ' + record.longitudeTo;
                    record.latLngFrom = record.latitudeFrom + ', ' + record.longitudeFrom;
                    record.speed = record.speed.toFixed(2);
                    record.distance = record.distance.toFixed(2);
                    record.engineHours = 'Encendido: ' + record.durationOn + '\nApagado:' + record.durationOff + '\nOcio:' + record.durationLeisure;
                });

            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }

            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });

    }

    showInMap(position: any) {
        this.position = position;
        let latLng = new google.maps.LatLng(position.latitude, position.longitude);
        this.options = {
            zoom: 13,
            center: latLng
        };
        let latLngTo = new google.maps.LatLng(position.latitudeTo, position.longitudeTo);

        let labelStart = {text: 'DESDE', color: 'deepskyblue', fontSize: '12px', fontWeight: 'bold'};
        let iconStart = {
            url: 'assets/layout/images/markers/blue.png', // url
            scaledSize: new google.maps.Size(45, 45), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(22.5, 38), // anchor,
            labelOrigin: new google.maps.Point(22, -5)
        };
        let labelFinal = {text: 'HASTA', color: 'green', fontSize: '12px', fontWeight: 'bold'};
        let iconFinal = {
            url: 'assets/layout/images/markers/green.png', // url
            scaledSize: new google.maps.Size(45, 45), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(22.5, 38), // anchor,
            labelOrigin: new google.maps.Point(22, -5)
        };

        this.overlays = [];
        this.displayLocation = true;

        let latLngFinal = null;

        let markerStart = new google.maps.Marker({position: latLng, icon: iconStart, label: labelStart});
        this.overlays.push(markerStart);

        let markerFinal = new google.maps.Marker({position: latLngTo, icon: iconFinal, label: labelFinal});
        this.overlays.push(markerFinal);

    }

    getAddressTo(record: any) {
        //let latLng = new google.maps.LatLng(position.latitudeTo, position.longitudeTo);
        let request = {
            latitude: record.latitudeTo,
            longitude: record.longitudeTo,
            idDevice: this.idDevice,
            deviceTime: record.to
        };
        this.blockedDocument = true;
        this.addressService.findAddressByCoordinates(request).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                record.toAddress = response.address;
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Dirección obtenida Exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });
        ;
    }

    getAddressFrom(record: any) {
        let request = {
            latitude: record.latitudeFrom,
            longitude: record.longitudeFrom,
            idDevice: this.idDevice,
            deviceTime: record.from
        };
        this.blockedDocument = true;
        this.addressService.findAddressByCoordinates(request).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                record.fromAddress = response.address;
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Dirección obtenida Exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });
        ;
    }

    hide() {
        this.displayLocation = false;
    }

    exportXLS() {
        let records = [];
        this.records.forEach(item => {
            let data = {};
            this.cols.forEach(col => {
                data[col.header] = item[col.field];
            });
            records.push(data);
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        XLSX.writeFile(workbook, this.fileName + '.xlsx');
    }

    exportPDF() {
        window.open(environment.reportsEndPoint + 'viewDistanceFuelConsumptionReport?' +
            'idDevice=' + this.idDevice +
            '&groupBy=' + this.groupBy +
            '&startDate=' + this.initialDate.toISOString() +
            '&endDate=' + this.finalDate.toISOString()
            , '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/app/distance-traveled-report/distance-traveled-report.component.ts